import { z } from 'zod';

export const IntlRateMode = z.enum(['truck-domestic', 'ocean-international', 'rail-domestic']);

export const RateBenchmarkSource = z.enum([
  'dat-truckstop', 'market-anonymized-flywheel',
  'drewry-wci', 'freightos-fbx', 'scfi', 'operator-custom-ocean',
  'stb-rail', 'operator-custom-rail',
]);

export const LaneRateSnapshot = z.object({
  id: z.string(),
  tenantId: z.string(),
  mode: IntlRateMode,
  laneKey: z.string(),
  origin: z.object({ code: z.string(), city: z.string(), country: z.string().optional() }),
  destination: z.object({ code: z.string(), city: z.string(), country: z.string().optional() }),
  windowStart: z.string(),
  windowEnd: z.string(),
  tenantRates: z.object({
    p10: z.number(), p50: z.number(), p90: z.number(),
    sampleCount: z.number(),
    unit: z.enum(['USD-per-mile', 'USD-per-FEU', 'USD-per-TEU', 'USD-per-carload', 'USD-per-mile-rail']),
  }),
  benchmark: z.object({
    source: RateBenchmarkSource,
    p50: z.number(),
    band: z.object({ low: z.number(), high: z.number() }),
    asOf: z.string(),
  }),
  variancePct: z.number(),
  generatedAt: z.string(),
});

export const RateInsightCommentary = z.object({
  id: z.string(),
  tenantId: z.string(),
  mode: IntlRateMode,
  windowStart: z.string(),
  windowEnd: z.string(),
  topDeviations: z.array(z.object({
    laneKey: z.string(),
    variancePct: z.number(),
    direction: z.enum(['above-market', 'below-market']),
    factorsCited: z.array(z.string()),
  })),
  body: z.string(),
  confidence: z.number().min(0).max(1),
  generatedAt: z.string(),
  correlationId: z.string(),
});
